/** Second-step and passkey helpers. Passkey ceremony outcomes → the PasswordSignIn port's ApiFailure codes (core ports.ts signInWithPasskey). */
import { AccountSecurityLogic, ApiFailure } from "@bundle/core";

/**
 * The code sent to /two-factor/verify-*: an authenticator code without spaces or dashes; a backup code exactly as
 * issued ("ve1H4-DZxZU"), trimmed only (Better Auth compares backup codes as stored).
 */
export function secondFactorCode(code: string, backup: boolean): string {
  return backup ? code.trim() : AccountSecurityLogic.normalizeCode(code);
}

export const passkeyFailure = (code: "passkey_cancelled" | "passkey_not_found" | "passkey_aborted") => new ApiFailure("invalid", 400, code, code);

/**
 * WebAuthn errors (via @simplewebauthn/browser's WebAuthnError, whose `cause` is the DOMException): a closed or timed-out
 * prompt is NotAllowedError (browsers don't say whether a passkey existed); AbortError = replaced by another ceremony.
 */
export function passkeyCeremonyFailure(e: unknown): ApiFailure {
  const err = e as { name?: string; code?: string; cause?: { name?: string } } | undefined;
  const name = err?.cause?.name ?? err?.name;
  if (name === "AbortError" || err?.code === "ERROR_CEREMONY_ABORTED") return passkeyFailure("passkey_aborted");
  if (name === "NotAllowedError" || name === "InvalidStateError") return passkeyFailure("passkey_cancelled");
  if (name === "SecurityError" || name === "NotSupportedError") return passkeyFailure("passkey_not_found");
  return passkeyFailure("passkey_cancelled");
}
